import globalAxios from 'axios';
import { B as BaseAPI, D as DUMMY_BASE_URL, s as setBearerAuthToObject, b as setSearchParams, c as serializeDataIfNeeded, t as toPathString, o as operationServerMap, d as createRequestFunction, e as BASE_PATH } from '../common-BuhUSHAi.js';

/* tslint:disable */
/* eslint-disable */
/**
 * BizWeb Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * SystemLogApi - axios parameter creator
 * @export
 */
const SystemLogApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll: async (options = {}) => {
            const localVarPath = `/v1/SystemLog/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById: async (id, options = {}) => {
            const localVarPath = `/v1/SystemLog/GetById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {SystemLogToken} [SystemLogToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert: async (SystemLogToken, options = {}) => {
            const localVarPath = `/v1/SystemLog/Insert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SystemLogToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove: async (id, options = {}) => {
            const localVarPath = `/v1/SystemLog/Delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {SystemLogToken} [SystemLogToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update: async (SystemLogToken, options = {}) => {
            const localVarPath = `/v1/SystemLog/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(SystemLogToken, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * SystemLogApi - functional programming interface
 * @export
 */
const SystemLogApiFp = function (configuration) {
    const localVarAxiosParamCreator = SystemLogApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAll(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemLogApi.getAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getById(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemLogApi.getById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {SystemLogToken} [SystemLogToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async insert(SystemLogToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.insert(SystemLogToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemLogApi.insert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async remove(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.remove(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemLogApi.remove']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {SystemLogToken} [SystemLogToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async update(SystemLogToken, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.update(SystemLogToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemLogApi.update']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * SystemLogApi - factory interface
 * @export
 */
const SystemLogApiFactory = function (configuration, basePath, axios) {
    const localVarFp = SystemLogApiFp(configuration);
    return {
        /**
         *
         * @summary  (Auth roles: System)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAll(options) {
            return localVarFp.getAll(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getById(id, options) {
            return localVarFp.getById(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {SystemLogToken} [SystemLogToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        insert(SystemLogToken, options) {
            return localVarFp.insert(SystemLogToken, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {number} [id]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        remove(id, options) {
            return localVarFp.remove(id, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary  (Auth roles: System)
         * @param {SystemLogToken} [SystemLogToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        update(SystemLogToken, options) {
            return localVarFp.update(SystemLogToken, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * SystemLogApi - object-oriented interface
 * @export
 * @class SystemLogApi
 * @extends {BaseAPI}
 */
class SystemLogApi extends BaseAPI {
    /**
     *
     * @summary  (Auth roles: System)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemLogApi
     */
    getAll(options) {
        return SystemLogApiFp(this.configuration).getAll(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemLogApi
     */
    getById(id, options) {
        return SystemLogApiFp(this.configuration).getById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {SystemLogToken} [SystemLogToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemLogApi
     */
    insert(SystemLogToken, options) {
        return SystemLogApiFp(this.configuration).insert(SystemLogToken, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {number} [id]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemLogApi
     */
    remove(id, options) {
        return SystemLogApiFp(this.configuration).remove(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary  (Auth roles: System)
     * @param {SystemLogToken} [SystemLogToken]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SystemLogApi
     */
    update(SystemLogToken, options) {
        return SystemLogApiFp(this.configuration).update(SystemLogToken, options).then((request) => request(this.axios, this.basePath));
    }
}

export { SystemLogApi, SystemLogApiAxiosParamCreator, SystemLogApiFactory, SystemLogApiFp };
//# sourceMappingURL=system-log-api.js.map
